// Paintings by Gary — minimal theme JS
// Most functionality is handled by Shopify natively; this is for UI polish.

document.addEventListener('DOMContentLoaded', function () {
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function (e) {
      const id = this.getAttribute('href');
      if (id === '#') return;
      const target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  // Cart count update (Shopify updates cart.item_count via AJAX)
  if (window.Shopify) {
    document.addEventListener('cart:updated', function () {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const count = document.querySelector('.cart-count');
          if (count) {
            count.textContent = cart.item_count;
            count.style.display = cart.item_count > 0 ? 'inline-block' : 'none';
          }
        });
    });
  }
});
